var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttLastNondirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 27,
    viewBox: "0 0 84 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-562 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(562 579)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.79,1307.378a3.823,3.823,0,0,0-3.571,2.445h-4.342a7.908,7.908,0,0,0-15.569,0h-4.326a3.851,3.851,0,0,0-7.157,0h-8.541a3.844,3.844,0,1,0,0,2.8h8.524a3.848,3.848,0,0,0,7.19,0h4.294a7.917,7.917,0,0,0,15.6,0h4.326a3.84,3.84,0,1,0,3.571-5.244Zm-10.76,5.244a5.121,5.121,0,0,1-9.875,0,4.837,4.837,0,0,1-.193-1.368,4.662,4.662,0,0,1,.209-1.431,5.117,5.117,0,0,1,9.843,0,4.662,4.662,0,0,1,.209,1.431A4.837,4.837,0,0,1,480.03,1312.622Z",
    transform: "translate(137.13 -718.309)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttLastNondirect);
export default __webpack_public_path__ + "static/media/att-last-nondirect.8fd73015082305b79add99f786485dce.svg";
export { ForwardRef as ReactComponent };